import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import Image from '../elements/Image';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';


const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

const Ai = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {

  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );



  return (
    <section id="Ai"
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <div className={splitClasses}>

            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left mt-12 mb-12 " data-reveal-container=".split-item">
               
                <h1 className="text-color-primary mt-0 mb-12 center-content">
                 DOGECOIN AI
                  </h1>
                     <div className='m-12 mt-12 mb-12 center-content'>
                      <p>
                           Meet our DOGECOIN AI on telegram.
                      </p>

                      <p>
                       Your ultimate Q&A companion! Ask any question, get fast and accurate answers. 
                      </p>
                      <p>
                         Unleash the power of knowledge today!
                     </p>
                  </div>

                      <div className="reveal-from-bottom center-content mt-32 mb-32" data-reveal-delay="600">
                <ButtonGroup>
                  <Button tag="a" color="primary" wideMobile href="https://t.me/Dogev2portal">
                    Telegram
                    </Button>
                
                </ButtonGroup>
              </div>
                </div>




              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/pic1.png')}
                  alt="Features split 01"
                  width={528}
                  height={396} />
              </div>



            </div>
      
          </div>
        </div>
      </div>
    </section>
  );
}

Ai.propTypes = propTypes;
Ai.defaultProps = defaultProps;

export default Ai;